module.exports = __webpack_public_path__ + "img/6.d3f6140a.jpg";